import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon} from './Icon'

type CheckCircleIconProps = {
  backgroundColor?: string
  checkColor?: string
  size?: IconSize
}

export const CheckCircleIcon: FC<React.PropsWithChildren<CheckCircleIconProps>> = ({
  backgroundColor = theme.palette.primary.main,
  checkColor = theme.palette.background.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="10" fill={backgroundColor} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6643 6.49481C15.12 6.99457 15.1106 7.79475 14.6433 8.28207L9.60879 13.5321C9.17531 13.9841 8.49249 14.0127 8.0273 13.5982L5.42542 11.2802C4.92393 10.8334 4.85606 10.0365 5.27382 9.50018C5.69159 8.96386 6.43679 8.89128 6.93827 9.33806L8.72151 10.9268L12.9931 6.47227C13.4604 5.98495 14.2087 5.99504 14.6643 6.49481Z"
          fill={checkColor}
        />
      </svg>
    </Icon>
  </>
)
